<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-25 15:01:36
-->
<template>
  <div>
    <div class="c-p-tb-20 c-btm-box c-f-ar c-bg-white">
      <div
        class="c-fc-center"
        v-for="(v, i) in list"
        :key="i"
        @click="itemHandle(v, i)"
      >
        <!-- <gImg
          size="66"
          :src="i === currentIdx ? v.selectedIconPath : v.iconPath"
          :title="v.text"
          fontSize="24"
        ></gImg> -->
        <img
          :src="i == currentIdx ? v.selectedIconPath : v.iconPath"
          alt=""
          class="c-w-40 c-m-b-10"
        />
        <p
          class="c-ft-24"
          :style="{ color: i == currentIdx ? '#333' : '#838383' }"
        >
          {{ v.text }}
        </p>
      </div>
    </div>
    <!-- <div class="inner-box"></div> -->
  </div>
</template>

<script>
export default {
  name: "GCustomTabbar",
  props: {
    currentIdx: {
      type: [Number, String],
    },
  },
  data() {
    return {
      // currentIdx: 0,
      list: [
        {
          text: "首页",
          pagePath: "HomePage",
          iconPath: require("@/assets/tabs/home.png"),
          selectedIconPath: require("@/assets/tabs/home-active.png"),
        },
        {
          text: "团购",
          pagePath: "GroupMall",
          iconPath: require("@/assets/tabs/points.png"),
          selectedIconPath: require("@/assets/tabs/points-active.png"),
        },
        {
          text: "订单",
          pagePath: "Order",
          iconPath: require("@/assets/tabs/order.png"),
          selectedIconPath: require("@/assets/tabs/order-active.png"),
        },
        {
          text: "我的",
          pagePath: "PersonCenter",
          iconPath: require("@/assets/tabs/mine.png"),
          selectedIconPath: require("@/assets/tabs/mine-active.png"),
        },
      ],
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    itemHandle(v, i) {
      // this.currentIdx = i;

      this.$router.push({
        name: v.pagePath,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.inner-box {
  height: calc(174rpx + env(safe-area-inset-bottom));
}
</style>
